jQuery(document).ready(function ($) {

  var shop_now_url = localStorage.getItem('current_product_page_url');
  if(shop_now_url && shop_now_url.length > 25){
    $(".uacf7-step a.shopnow").attr('href',shop_now_url);
  }

  function get_input(){
    mtsi_data = {
      method: $('input[name="mtsi_method"]:checked').val(),
      header: $('input[name="mtsi_header_type"]:checked').val(),
      width: parseFloat($("#mtsi_custom_curtain_width").val()) ,
      height: parseFloat($("#mtsi_custom_curtain_height").val()),
      panelType:$('input[name="mtsi_panel_type"]:checked').val(),
      roomName:$("#room_name").val() || "",
      lining:$('input[name="mtsi_custom_curtain_lining"]:checked').val(),
      bottom:$('input[name="mtsi_bottom"]:checked').val(),
      above:$('input[name="mtsi_above"]').val(),
      puddle:$('input[name="mtsi_puddle"]').val(),
      fullness:$('input[name="mtsi_fullness"]:checked').val(),
    };

    calc_size(mtsi_data);
    console.log(mtsi_data);
    $(".method_html").html(mtsi_data.method);
    $(".type_html").html(mtsi_data.header);
    return mtsi_data;
  }

  function calc_size(data){
    width = data.width;
    data.result_height = data.height;

    if(data.method == 'Rod'){
      switch (data.header) {
        case "Grommet":
          data.result_height += 1.5;
          break;
        case "Rod Pocket":
          data.result_height += 1.5;
          break;
        case "Double Pinch Pleat":
          data.result_height = data.height - 2;
          break;
        case "Triple Pinch Pleat":
          data.result_height = data.height - 2;
          break;
      }
    }else if(data.method == 'Track'){
      // switch (data.header) {
      // 	case "Double-Pinch Pleat":
      // 		data.result_height -= 0.5;
      // 		break;
      // 	case "Triple-Pinch Pleat":
      // 		data.result_height -= 0.5;
      // 		break;
      // 	case "S-fold":
      // 		data.result_height = data.height - 2;
      // 		break;
      // }
    }

    //"Single Panel" "Split Panels
    if (data.panelType == "Split Panels") {
      width /= 2;
    }

    fixed_fullness = ['Double Pinch Pleat', 'Triple Pinch Pleat', 'S-Fold' , 'Double-Pinch Pleat' , 'Triple-Pinch Pleat'];
    if(!fixed_fullness.includes(data.header)){
      //倍数计算
      fullness = 1;
      if(data.fullness=="1x Fullness"){
        fullness = 1;
      }else if(data.fullness=="1.5x Fullness"){
        fullness = 1.5;
      }else if(data.fullness=="2x Fullness"){
        fullness = 2;
      }else if(data.fullness=="2.5x Fullness"){
        fullness = 2.5;
      }
      width*=fullness;
    }

    //'Above Floor' "Kiss Floor" 'Puddle'
    if(data.bottom=="Above Floor"){
      data.result_height = parseFloat(data.result_height) - parseFloat(data.above?data.above:0);
    }else if(data.bottom=="Puddle"){
      data.result_height = parseFloat(data.result_height) + parseFloat(data.puddle?data.puddle:0);
    }

    data.result_width = width;
    
    $(".width_height_html").html(data.result_width+'"W x '+data.result_height+'"L');
    if(data.panelType == 'Single Panel'){
      data.panels = 1;
      $(".panels_html").html(data.panels+' Panel');
    }else if(data.panelType == 'Split Panels'){
      data.panels = 2;
      $(".panels_html").html(data.panels+' Panels');
    }
    if(width && data.panelType && data.bottom){
      localStorage.setItem("mtsi_data", JSON.stringify(data));
    }
    return data;
  }

  //跳转步骤
  $("div.steps-step", this).on('click', function(){
    this_class = $(this).attr('class');
    if(this_class.search("complete")>0){
      link_a = $(this).find('a');
      href=(link_a.attr('href')).replace("#", '');
      $('.btn-circle').removeClass("uacf7-btn-active");
      $('.step-content').hide();
      $('#'+href).show();
      $('a[href|="#'+href+'"]').addClass("uacf7-btn-active");
    }
  });

  function initHeaderType(){
    $(".uacf7-form-22972 #mtsi_header_type").html(
      '<span class="wpcf7-list-item first"><label><input type="radio" name="mtsi_header_type" value="Grommet" checked="checked"><span class="wpcf7-list-item-label">Grommet</span></label><div class="mtsi-heading"><h6 class="mtsi-title">Grommet</h6><p>Features 1.6" inner diameter <br> grommets for a sleek look.</p> </div></span>'+
      '<span class="wpcf7-list-item"><label><input type="radio" name="mtsi_header_type" value="Rod Pocket"><span class="wpcf7-list-item-label">Rod Pocket</span></label><div class="mtsi-heading"><h6 class="mtsi-title">Rod Pocket</h6><p>Best suited for a gathered <br> look with 2X fabric fullness.</p> </div></span>'+
      '<span class="wpcf7-list-item"><label><input type="radio" name="mtsi_header_type" value="Back Tab"><span class="wpcf7-list-item-label">Back Tab</span></label><div class="mtsi-heading"><h6 class="mtsi-title">Back Tab</h6><p>4" hidden tabs <br> for a clean finish.</p> </div></span>'+
      '<span class="wpcf7-list-item"><label><input type="radio" name="mtsi_header_type" value="Double Pinch Pleat"><span class="wpcf7-list-item-label">Double Pinch Pleat</span></label><div class="mtsi-heading"><h6 class="mtsi-title">Double Pinch Pleat</h6><p>Suitable for <br> Euro-style double pleats.</p> </div></span>'+
      '<span class="wpcf7-list-item"><label><input type="radio" name="mtsi_header_type" value="Triple Pinch Pleat"><span class="wpcf7-list-item-label">Triple Pinch Pleat</span></label><div class="mtsi-heading"><h6 class="mtsi-title">Triple Pinch Pleat</h6><p>Designed for <br> Euro Triple Pleats.</p> </div></span>'+
      '<span class="wpcf7-list-item"><label><input type="radio" name="mtsi_header_type" value="Tab Top"><span class="wpcf7-list-item-label">Tab Top</span></label><div class="mtsi-heading"><h6 class="mtsi-title">Tab Top</h6><p>4" tabs provide stability <br> but limit sliding.</p> </div></span>'
      );
  }
  initHeaderType();
  $('.uacf7-form-22972 input[name="mtsi_method"] , #22972step-1 button.uacf7-next').on("change , click", function () {
    input = get_input();
    if(input.method == 'Rod'){
      initHeaderType();
    }else if(input.method == 'Track'){
      $("#mtsi_header_type").html(
      '<span class="wpcf7-list-item"><label><input type="radio" name="mtsi_header_type" value="Double-Pinch Pleat" checked="checked"><span class="wpcf7-list-item-label">Double-Pinch Pleat</span></label><div class="mtsi-heading"><h6 class="mtsi-title">Double-Pinch Pleat</h6><p>Suitable for <br> Euro-style double pleats.</p> </div></span>'+
      '<span class="wpcf7-list-item"><label><input type="radio" name="mtsi_header_type" value="Triple-Pinch Pleat"><span class="wpcf7-list-item-label">Triple-Pinch Pleat</span></label><div class="mtsi-heading"><h6 class="mtsi-title">Triple-Pinch Pleat</h6><p>Designed for <br> Euro Triple Pleats.</p> </div></span>'+
      '<span class="wpcf7-list-item last"><label><input type="radio" name="mtsi_header_type" value="S-Fold"><span class="wpcf7-list-item-label">S-Fold</span></label><div class="mtsi-heading"><h6 class="mtsi-title">S-Fold</h6><p>S-shape folds for <br> ripple track systems only.</p> </div></span>'
      );
    }
  });

  let fixed_fullness = ['Double Pinch Pleat', 'Triple Pinch Pleat', 'S-Fold' , 'Double-Pinch Pleat' , 'Triple-Pinch Pleat'];
    function getImgUrl(method = 'Rod', header = 'Grommet', panelType, fullness, bottom) {
    // Shopify CDN 基础路径
    const baseUrl = 'https://cdn.shopify.com/s/files/1/0752/7399/4425/files/';
    
    // 构建文件名
    let filename = method;
    
    // 添加 header（替换空格为连字符）
    if (header) {
        filename += '_' + header.replaceAll(' ', '-');
    } else {
        return;
    }
    
    // 添加 panelType
    if (panelType == 'Split Panels') {
        filename += '_Split-Panels';
    } else {
        filename += '_Single-Panel';
    }
    
    // 添加 bottom（转换为拼音）
    if (bottom == 'Above Floor') {
        filename += '_lidi';  // 离地
    } else if (bottom == 'Puddle') {
        filename += '_tuodi';  // 拖地
    } else {
        filename += '_jindi';  // 近地
    }
    
    // 添加 fullness（仅当不在 fixed_fullness 列表中时）
    if (!fixed_fullness.includes(header)) {
        if (fullness) {
        filename += '_' + parseFloat(fullness);
        } else {
        filename += '_2';
        }
    }
    
    filename += '.png';
    
    return baseUrl + filename;
    }


  //设置离地选项图片
  $('.uacf7-form-22972 button.uacf7-next , .uacf7-form-22972 input[name="mtsi_method"], .uacf7-form-22972 input[name="mtsi_header_type"], input[name="mtsi_panel_type"], input[name="mtsi_fullness"], input[name="mtsi_bottom"]').on("change , click", function () {
    input = get_input();

    //宽高描述
    if(input.method == 'Rod'){
      $('#22972step-3 .text-center').html("<h5 class='h2s2'>What's Your Rod Width?</h5><p>Frame outer edge to edge</p>");
      $('#22972step-4 .text-center').html("<h5 class='h2s2'>What's the Height from Rod Top to Floor?</h5>");
      $('#22972step-3 .kuangao-img img').attr("src", "https://cdn.shopify.com/s/files/1/0752/7399/4425/files/part3_rod_b0838ee1-9de8-486a-85c3-76d24777871c.png?v=1767778601");
      $('#22972step-4 .kuangao-img img').attr("src", "https://cdn.shopify.com/s/files/1/0752/7399/4425/files/part4_rod_fda962d7-c771-421a-b8bf-1537a0752797.png?v=1767779561");
      $('.width-description').html(
        "<p>① The length of the rod (finials excluded),You need to input this data <br> ② To achieve the perfect effect, we suggest that the curtain rod should extend at least 6-10 inches beyond both sides of the window.</p>"
      );
      $('.height-description').html(
        '<p>① the Height from Rod Top to Floor,You need to input this data <br> ② For better visual height in a room, mount the Rod closer to the ceiling, at least 6-8" above the window frame.</p>'
      );
      if(input.header=='Rod Pocket' || input.header== 'Back Tab' || input.header== 'Tab Top'){
        $('input[name="mtsi_fullness"][value="1x Fullness"]').parent().parent().show();
      }else{
        $('input[name="mtsi_fullness"][value="1x Fullness"]').parent().parent().hide();
      }
    }else if(input.method == 'Track'){
      $('#22972step-3 .text-center').html("<h5 class='h2s2'>What's Your Track Width?</h5>");
      $('#22972step-4 .text-center').html("<h5 class='h2s2'>What's the Height from Track Eyelet to Floor?</h5>");
      $('#22972step-3 .kuangao-img img').attr("src", "https://cdn.shopify.com/s/files/1/0752/7399/4425/files/part3_track.png?v=1767779620");
      $('#22972step-4 .kuangao-img img').attr("src", "https://cdn.shopify.com/s/files/1/0752/7399/4425/files/part4_track.jpg?v=1767779659");
      $('.width-description').html(
        "<p>① The length of the track,You need to input this data <br> ② To achieve the perfect effect, we suggest that the curtain track should extend at least 6-10 inches beyond both sides of the window..</p>"
      );
      $('.height-description').html(
        '<p>① the curtain length is measured from track ring eyelet to floor,You need to input this data <br> ② For better visual height in a room, mount the Track closer to the ceiling, at least 6-8" above the window frame.</p>'
      );
    }

    //fullness 描述
    if(fixed_fullness.includes(input.header)){
      $(".optional_fullness").hide();
      $(".fixed_fullness").show();
      if(input.header=='Double Pinch Pleat' || input.header== 'Double-Pinch Pleat'){
        $(".fixed_fullness").html(
          '<img>'+
          "<p>Features: Built-in 2x fullness with a classic two-fold pleat design at the top.</p>"+
          "<p>Size Details: The ordered panel width equals the top width, and the bottom hem width is 2x the top width.</p>"
          );
      }else if(input.header=='Triple Pinch Pleat' || input.header=='Triple-Pinch Pleat'){
        $(".fixed_fullness").html(
          '<img>'+
          "<p>Features: Built-in 2.5x fullness with a classic three-fold pleat design, offering a luxurious and fuller bottom.</p>"+
          "<p>Size Details: The ordered panel width equals the top width, and the bottom hem width is 2.5x the top width.</p>"
          );
      }else if(input.header=='S-Fold'){
        $(".fixed_fullness").html(
          '<img>'+
          "<p>Features: Unique wave-like design with 2.6x natural fullness, offering a sleek and elegant appearance.</p>"+
          "<p>Details: 2.76-inch runner spacing. Utilizes ripple fold track system comes with 4.72-inch or 6.3-inch spaced fabric straps. The flat panel width is approximately 2.6x the track width.</p>"
          );
      }
      $('.fullnessDescription').html('');
    }else{
      $(".optional_fullness").show();
      $(".fixed_fullness").hide();
      
      $('input[name="mtsi_fullness"][value="1x Fullness"]').next().css("content",
      "url("+getImgUrl(input.method,input.header,input.panelType,1,input.bottom)+")");
      $('input[name="mtsi_fullness"][value="1.5x Fullness"]').next().css("content",
      "url("+getImgUrl(input.method,input.header,input.panelType,1.5,input.bottom)+")");
      $('input[name="mtsi_fullness"][value="2x Fullness"]').next().css("content",
      "url("+getImgUrl(input.method,input.header,input.panelType,2,input.bottom)+")");
      $('input[name="mtsi_fullness"][value="2.5x Fullness"]').next().css("content",
      "url("+getImgUrl(input.method,input.header,input.panelType,2.5,input.bottom)+")");

      switch(input.fullness)
      {
        case '1x Fullness':
          $('.fullnessDescription').html(
            '<p>Features: Appears flat and sheet-like when curtains are drawn.<br>'+
            'Note: Equal to 1x the width of the curtain rod or track.</p>'
          );
          break;
        case '1.5x Fullness':
          $('.fullnessDescription').html(
            '<p>Features: Provides light pleats using 1.5 times the fabric width.<br>'+
            'Note: Not ideal for windows over 50" wide to prevent a flat appearance.</p>'
          );
          break;
        case '2x Fullness':
          $('.fullnessDescription').html(
            '<p>Features: Soft pleats and a nicely gathered look using 2 times the fabric width.<br>'+
            'Note: Strongly recommended for a balanced and elegant appearance.</p>'
          );
          break;
        case '2.5x Fullness':
          $('.fullnessDescription').html(
            '<p>Fabric Usage: Equal to 2.5x the width of the curtain rod or track.<br>'+
            'Best For: Enhancing the elegance of sheer curtains, Not suitable for small windows. Rich pleats create a generous look, ideal for large windows</p>'
          );
          break;
      }
    }
    $('.uacf7-form-22972 input[name="mtsi_panel_type"][value="Single Panel"]').next().css("content",
    "url("+getImgUrl(input.method,input.header,'Single Panel',input.fullness,input.bottom)+")");
    $('.uacf7-form-22972 input[name="mtsi_panel_type"][value="Split Panels"]').next().css("content",
    "url("+getImgUrl(input.method,input.header,'Split Panels',input.fullness,input.bottom)+")");
    $('input[name="mtsi_bottom"][value="Kiss Floor"]').next().css("content",
    "url("+getImgUrl(input.method,input.header,input.panelType,input.fullness,'Kiss Floor')+")");
    $('input[name="mtsi_bottom"][value="Above Floor"]').next().css("content",
    "url("+getImgUrl(input.method,input.header,input.panelType,input.fullness,'Above Floor')+")");
    $('input[name="mtsi_bottom"][value="Puddle"]').next().css("content",
    "url("+getImgUrl(input.method,input.header,input.panelType,input.fullness,'Puddle')+")");
    $(".fixed_fullness img , .uacf7-form-22972 .alldone img ").attr("src", 
    getImgUrl(input.method,input.header,input.panelType,input.fullness,input.bottom));

  });

});